import {
    AccessEntry,
    ColoredSquare,
    ProjectMetadata,
    ShareLink,
    ProjectLocalEvent,
    ProjectEventType,
    ProjectWorldEntities,
    ProjectUser
} from '@/ProjectWorld';
import { injectable } from 'tsyringe';
import { EventSourceStore, IEventSourceStore } from '@utilitydelta/clientside-event-sourcing';

// Store names
const STORE_EVENTS = 'Events';
const STORE_PROJECTS = 'Projects';
const STORE_SHARELINKS = 'ShareLinks';
const STORE_ACCESSENTRIES = 'AccessEntries';
const STORE_SQUARES = 'Squares';
const STORE_PROJECTUSERS = 'ProjectUsers';

// App configuration
const APP_NAME = 'UtilityDelta';
const DB_VERSION = 4;

export const TOKEN_ILocalData = Symbol('ILocalData');

export interface ILocalData {
    store: IEventSourceStore<ProjectEventType, ProjectLocalEvent, ProjectMetadata, ProjectWorldEntities, ProjectEntityTypes>;
}

export type ProjectEntityTypes = {
    shareLinks: ShareLink;
    accessEntries: AccessEntry;
    coloredSquares: ColoredSquare;
    projectUsers: ProjectUser;
};

@injectable()
export class LocalData implements ILocalData {
    private _store: IEventSourceStore<ProjectEventType, ProjectLocalEvent, ProjectMetadata, ProjectWorldEntities, ProjectEntityTypes>;
    public get store() {
        return this._store;
    }
    constructor() {
        this._store = new EventSourceStore<ProjectEventType, ProjectLocalEvent, ProjectMetadata, ProjectWorldEntities, ProjectEntityTypes>({
            appName: APP_NAME,
            dbVersion: DB_VERSION,
            storeNames: {
                events: STORE_EVENTS,
                aggregates: STORE_PROJECTS,
                entities: {
                    shareLinks: STORE_SHARELINKS,
                    accessEntries: STORE_ACCESSENTRIES,
                    coloredSquares: STORE_SQUARES,
                    projectUsers: STORE_PROJECTUSERS,
                }
            }
        });
    }
}